import { FC } from 'react'
import moment from 'moment'
import { Spinner } from 'react-bootstrap'
import { PotentialChurnItems } from '../../../../../services/cellcast.type'
import { AuthenticateUser } from '../../../../Utils/_helpers/RoleAndPermission'
import { useDispatch } from 'react-redux'
import { ProfileDetailData } from '../../../../Redux/AdminPanel/ProfileDetailsSlice'
import { useNavigate } from 'react-router-dom'
import ReactPaginate from 'react-paginate'

interface Props {
  data: PotentialChurnItems | null | undefined
  isFetching: boolean
  handleSetParams: (field: string, value: string) => void
  updateStatusUsedCoupon: (id: string, status: boolean) => Promise<void>
}

export const PotentialChurnTable: FC<Props> = ({ data, isFetching, handleSetParams, updateStatusUsedCoupon }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  return (
    <div className='card-body p-0 pt-1'>
      <div className='table-responsive'>
        <table className='table align-middle gs-0 gy-5'>
          <thead>
            <tr className='fw-bold text-muted'>
              <th>Account Name</th>
              <th>Last Login</th>
              <th>Last Send</th>
              <th>Last Purchase</th>
              <th>Assigned Staff</th>
              <th>Feature Usage</th>
              <th>Potential Churn</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {isFetching ? (
              <tr>
                <td colSpan={11} className='text-center'>
                  <Spinner size='sm' animation='border' variant='primary' />
                </td>
              </tr>
            ) : (
              data && data?.items?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <span
                      onClick={() => {
                        if (AuthenticateUser('edit-user')) {
                          dispatch(ProfileDetailData(item?._id))
                          navigate(`/user-profile`)
                        }
                      }}
                      className='text-dark fw-bolder text-hover-primary fs-6 d-flex flex-column'
                    >
                      {item?.name}
                      <small className='text-muted'>{item.email}</small>
                    </span>
                  </td>
                  <td>
                    <div className='d-flex flex-column'>
                      {item.lastLogin ? moment(item.lastLogin).format('DD/MM/YYYY') : '-'}
                    </div>
                  </td>
                  <td>
                    <div className='d-flex flex-column'>
                      {item.lastSend ? moment(item.lastSend).format('DD/MM/YYYY') : '-'}
                    </div>
                  </td>
                  <td>
                    <div>{item.lastPurchase ? moment(item.lastPurchase).format('DD/MM/YYYY') : '-'}</div>
                  </td>
                  <td>{item?.staff?.name}</td>
                  <td>
                    {item.features &&
                      item.features.map((feature, idx) => (
                        <span key={idx} className="badge badge-light-primary me-1">
                          {feature}
                        </span>
                      ))}
                  </td>
                  <td>
                    <span
                      className={`badge ${item.potentialChurn ? 'badge-light-danger' : 'badge-light-success'
                        }`}
                    >
                      {item.potentialChurn ? 'Risk' : 'Un Risked'}
                    </span>
                  </td>
                  <td>
                    <button onClick={() => updateStatusUsedCoupon(item?._id, !item.hasUsedCoupon)} disabled={!item.hasUsedCoupon} className='btn btn-sm btn-light btn-active-light-primary'>
                      Reopen
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className='abcd'>
        <select
          onChange={(e: any) => {
            handleSetParams('limit', e.target.value)
          }}
          value={data?.limit || 10}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>
        {isFetching
          ? '. . . . .'
          : `Show ${data?.items?.length} of ${data?.total} Account`}
        <ReactPaginate
          previousLabel='<'
          nextLabel='>'
          pageCount={data?.totalPages ? data.totalPages : 0}
          onPageChange={(e: any) => {
            handleSetParams('page', (e.selected + 1).toString())
          }}
          containerClassName={'pagination'}
          previousLinkClassName={'pagination__link'}
          nextLinkClassName={'pagination__link'}
          disabledClassName={'pagination__link--disabled'}
          activeClassName={'pagination__link--active'}
        />
      </div>
    </div>
  )
}